export default {
  totalClaim: ({ claims }) => claims.totalClaim,
};
